import { SentryServiceInterface } from 'utils/integrations/Sentry/types';
import * as Sentry from '@sentry/react';
import { Environment, getEnvironmentValue } from 'utils/environment';
import { Integrations } from '@sentry/tracing';
import User from 'auth/User';
import { Nullable } from 'utils/types';

const ENV_SENTRY_DSN_NAME = 'REACT_APP_SENTRY_DSN';

class SentryService implements SentryServiceInterface {
  constructor(private readonly env: Environment, private readonly user: Nullable<User>) {}

  init() {
    const user = this.user;
    Sentry.init({
      dsn: getEnvironmentValue(ENV_SENTRY_DSN_NAME),
      autoSessionTracking: true,
      integrations: [new Integrations.BrowserTracing()],
      environment: this.env,
      beforeSend(event, hint) {
        if (user) {
          event.user = {
            id: user.id.toString(),
            username: user.name,
            email: user.email,
          };
        }
        return event;
      },
    });
  }

  captureException(error: Error) {
    Sentry.captureException(error);
  }
}

export class MockyService implements SentryServiceInterface {
  captureException() {}
  init() {}
}

export default SentryService;
